import React, { useEffect, useState } from "react";
import SideMenu from "../sideMenu";
import { Loader } from "../loader";
import { CustomText, PrimaryCta, PrimaryCtaInvert } from "../../components";
import { ModalComponent } from "../../components";
import Utils from "../../common/utils";
import Theme from "../../resources/themes/light";
import Core from "../../common/clientSdk";
import { useSnackbar } from "react-simple-snackbar";
import Header from "../header";
import Icon from "../../components/core_component/icon";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "react-modal";

function PayoutDetailScreen(props) {
  const [isLoading, setLoading] = useState(false);
  const [kycData, setKycData] = useState([]);
  const [influencerData, setInfluencerData] = useState();
  const [contractData, setContractData] = useState({});
  const [campaignData, setCampaignData] = useState({});
  const [payoutListData, setPayOutListData] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [effectiveLoad, setEffectiveLoad] = useState(false);
  const [isPayoutCompleted, setIsPayoutCompleted] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [rejectModalIsOpen, setRejectModalIsOpen] = useState(false);
  const [payout_id, setPayoutId] = useState(props.item);
  const [rejectPayoutLoading, setRejectPayoutLoading] = useState(false);

  // const [initiateTransferClicked, setInitiateTransferClicked] = useState(false);

  const navigate = useNavigate();

  const [openSnackbar] = useSnackbar();

  function updateProgress(status) {
    setLoading(status);
  }

  useEffect(() => {
    payoutDetailsAdmin(updateProgress);
  }, []);

  useEffect(() => {
    if (payoutListData) {
      setIsPayoutCompleted(payoutListData?.status);
    }
  }, [payoutListData]);

  //  -------------- Api calls -------------------

  const payoutDetailsAdmin = () => {
    const params = { payout_id: payout_id };
    Core.payoutAdminDetails(
      payoutDetailsAdminSuccess,
      payoutDetailsAdminFailed,
      updateProgress,
      params,
    );
  };

  const payoutDetailsAdminSuccess = (response) => {
    console.log("response", response);
    setPayOutListData(response.payout_details || []);
    getInfluencerDetailAdmin(response.payout_details.influencer_id);
    assignmentAdminDetails(response.payout_details.assignment_id);
  };

  const payoutDetailsAdminFailed = (errorList) => {
    openSnackbar(errorList.map((item) => item.m).join(", "));
  };

  console.log("payoutListData", payoutListData);

  function getInfluencerDetailAdmin(influencer_id) {
    var params = {
      influencer_id: influencer_id,
    };
    Core.getInfluencerAdminDetail(
      getInfluencerDetailAdminSuccess,
      getInfluencerDetailAdminFailed,
      updateProgress,
      params,
    );
  }

  function getInfluencerDetailAdminSuccess(response) {
    console.log("inf res", response);
    setInfluencerData(response.influencer_deep_data || []);
    setKycData(response.influencer_deep_data.kyc_data || []);
    setLoading(false);
  }
  console.log("influencer ", influencerData);

  function getInfluencerDetailAdminFailed(errorList) {
    openSnackbar(errorList.map((item) => item.m).join(", "));
  }

  function assignmentAdminDetails(assignment_id) {
    const params = {
      assignment_id: assignment_id,
    };
    Core.assignmentAdminDetails(
      assignmentAdminDetailsSuccess,
      assignmentAdminDetailsFailed,
      updateProgress,
      params,
    );
  }

  function assignmentAdminDetailsSuccess(response_data) {
    setContractData(response_data.assignment_deep_data.assignment_data || []);
    setCampaignData(response_data?.assignment_deep_data?.campaign_data);
  }

  function assignmentAdminDetailsFailed(errorList) {
    openSnackbar(errorList.map((item) => item.m).join(", "));
  }
  function payoutCompleteMarkAdmin() {
    const params = {
      payout_id: payout_id,
    };
    Core.payoutCompleteMarkAdmin(
      payoutCompleteMarkAdminSuccess,
      payoutCompleteMarkAdminFailed,
      updateProgress,
      params,
    );
  }

  function payoutCompleteMarkAdminSuccess() {
    toast.success("Payout marked as completed!");
    closeModal();
    if (props.onActionComplete) {
      props.onActionComplete(); // This will refresh the parent list
    }
  }

  function payoutCompleteMarkAdminFailed(errorList) {
    openSnackbar(errorList.map((item) => item.m).join(", "));
    closeModal();
  }

  const openRejectModal = () => {
    setRejectModalIsOpen(true);
  };

  const closeRejectModal = () => {
    setRejectModalIsOpen(false);
  };

  function rejectPayout() {
    let params = {
      payout_id: payout_id,
    };
    Core.rejectPayout(
      rejectPayoutSuccess,
      rejectPayoutFailed,
      (status) => setRejectPayoutLoading(status),
      params,
    );
  }

  function rejectPayoutSuccess(response) {
    toast.success("Payout rejected successfully");
    setRejectPayoutLoading(false);
    closeRejectModal();
    if (props.onActionComplete) {
      props.onActionComplete(); // This will refresh the parent list
    }
  }

  function rejectPayoutFailed(errorList) {
    setRejectPayoutLoading(false);
    closeRejectModal();
    if (Array.isArray(errorList)) {
      toast.error(errorList.map((item) => item.m).join(", "));
    } else {
      toast.error(errorList || "Failed to reject payout");
    }
  }

  const assignment_id = contractData?.assignment_id;

  // Core.payoutAdminInitiateTransfer   --------- [ For Button Api ] call it

  const toggleModal = () => {
    setOpenModal((prevState) => !prevState);
  };

  const handleInitateTransfer = () => {
    const params = { payout_id: payout_id };
    Core.payoutAdminInitiateTransfer(
      hanldeInitiateTranferSuccess,
      handleInitiateTransferFailed,
      (status) => setEffectiveLoad(status),
      params,
    );
  };

  function hanldeInitiateTranferSuccess(response_data) {
    console.log("transfer", response_data);
    setOpenModal(false);
    setEffectiveLoad(false);
    toast.success("Transfer initiated successfully!");
    payoutDetailsAdmin();
    if (props.onActionComplete) {
      props.onActionComplete(); // This will refresh the parent list
    }
  }

  function handleInitiateTransferFailed(errorList) {
    openSnackbar(errorList?.map((item) => item?.m).join(", "));
    setOpenModal(false);
  }

  function contactDetailPage(assignment_id) {
    window.open(`/contractDetail/${assignment_id}`, "_blank");
  }

  const toFixedTwo = (value) => Number(value).toFixed(1);

  const renderSummaryItem = (label, value) => (
    <div style={{ marginBottom: 8 }}>
      <CustomText
        p
        text={label}
        fontSize={"font_size_small"}
        textColor={"text_grey_400_color"}
        fontWeight={"Poppins_regular_large"}
        textAlign={"text_align_left"}
      />
      <CustomText
        p
        text={value || "N/A"}
        fontSize={"font_size_medium"}
        textColor={"text_color_primary"}
        fontWeight={"Poppins_regular_large"}
        textAlign={"text_align_left"}
      />
    </div>
  );

  const getStatusChipStyle = (status) => {
    const baseColor =
      status === "COMPLETED"
        ? Theme.colors.TC_COMPLETED
        : status === "PENDING"
          ? "#ffffff" : status === "PAYMENT_INITIATED" ? "var(--gray-gray-200)"
          : Theme.colors.TC_SECONDARY;
    const backgroundColor =
      status === "COMPLETED"
        ? "#ffffff"
        : status === "PENDING"
          ? "rgb(255, 172, 5)" : status === "PAYMENT_INITIATED" ? Theme.colors.BL_200
          : Theme.colors.TC_SECONDARY;

    return {
      padding: "4px 10px",
      borderRadius: 999,
      borderColor:"var(--gray-gray-100)",
      border:"1px solid var(--gray-gray-50)",
      backgroundColor: backgroundColor,
      color: baseColor,
      fontSize: 12,
      fontFamily: Theme.fonts.SEMI_BOLD,
      textTransform: "uppercase",
      letterSpacing: 0.3,
    };
  };

  function renderBankDetails() {
    if (!influencerData.influencer_data?.is_bank_verified) {
      return (
        <div className="p-l-12 m-t-12" style={{ flex: 1 }}>
          <CustomText
            p
            text={"Bank is not verified."}
            fontSize={"font_size_large"}
            textColor={"text_color_primary"}
            fontWeight={"Poppins_regular_large"}
            textAlign={"text_align_left"}
          />
        </div>
      );
    } else {
      return (
        <div className=" m-t-12" style={{ flex: 1 }}>
          <div className="engagement-view-inner ">
            <div className="instagram-data-view">
              <div>
                <div className="Kycdetails">
                  <div className="KycLeft">
                    <ul>
                      <li>
                        <h6>Influencer Id:</h6>
                        <span>
                          {influencerData.influencer_data?.influencer_id ||
                            "N/A"}
                        </span>
                      </li>
                      <li>
                        <h6>Account Holder:</h6>
                        <span>
                          {influencerData.bank_data?.account_holder || "N/A"}
                        </span>
                      </li>
                      <li>
                        <h6>Bank Name:</h6>
                        <span>
                          {" "}
                          {influencerData.bank_data?.bank_name || "N/A"}{" "}
                        </span>
                      </li>
                      <li>
                        <h6>Account Number:</h6>
                        <span>
                          {" "}
                          {influencerData.bank_data?.account_number ||
                            "N/A"}{" "}
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="KycRight">
                    <ul>
                      <li>
                        <h6>IFSC Code:</h6>
                        <span>
                          {influencerData.bank_data?.ifsc_code || "N/A"}
                        </span>
                      </li>
                      <li>
                        <h6>PAN:</h6>
                        <span>
                          {influencerData.kyc_data?.find(
                            (k) => k.kyc_id_type === "PAN",
                          )?.kyc_value || "N/A"}
                        </span>
                      </li>
                      <li>
                        <h6>GST:</h6>
                        <span>
                          {influencerData.kyc_data?.find(
                            (k) => k.kyc_type === "GST",
                          )?.kyc_value || "N/A"}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
  // function renderPayoutDetails() {
  //   if (!payoutListData) {
  //     return (
  //       <div className=" p-b-12 m-t-12">
  //         <CustomText
  //           p
  //           text={"Payout Details are not available."}
  //           fontSize={"font_size_large"}
  //           textColor={"text_color_primary"}
  //           fontWeight={"Poppins_regular_large"}
  //           textAlign={"text_align_left"}
  //         />
  //       </div>
  //     );
  //   } else {
  //     return (
  //       <div>
  //         <div className="Kycdetails">
  //           <div className="KycLeft">
  //             <ul>
  //               <li>
  //                 <h6>Completed Date :</h6>
  //                 <span>
  //                   {" "}
  //                   {Utils.formatDate(payoutListData?.date_completed || "N/A")}
  //                 </span>
  //               </li>

  //               <li>
  //                 <h6>Schedule Date :</h6>
  //                 <span>
  //                   {Utils.formatDate(payoutListData?.date_scheduled || "N/A")}
  //                 </span>
  //               </li>
  //               <li>
  //                 <h6> Status :</h6>
  //                 <span>{payoutListData?.status || "N/A"}</span>
  //               </li>
  //             </ul>
  //           </div>
  //           <div className="KycRight">
  //             <ul>
  //               <li>
  //                 <h6>Platform Charges :</h6>
  //                 <span>{payoutListData?.platform_charges || "N/A"}</span>
  //               </li>
  //               <li>
  //                 <h6>Order Amount :</h6>
  //                 <span>
  //                   {toFixedTwo(payoutListData?.order_amount) || "N/A"}
  //                 </span>
  //               </li>
  //               <li>
  //                 <h6>Tax Amount :</h6>
  //                 <span>
  //                   {" "}
  //                   {toFixedTwo(payoutListData?.tax_amount) || "N/A"}{" "}
  //                 </span>
  //               </li>
  //               <li>
  //                 <h6> Pay Amount :</h6>
  //                 <span>
  //                   {" "}
  //                   {toFixedTwo(payoutListData?.payout_amount) || "N/A"}{" "}
  //                 </span>
  //               </li>
  //             </ul>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   }
  // }
  function renderContractDetails() {
    if (!contractData) {
      return (
        <div className=" p-l-12 m-t-12" style={{ flex: 1, alignItems: "left" }}>
          <CustomText
            p
            text={"Contract Details are not available."}
            fontSize={"font_size_large"}
            textColor={"text_color_primary"}
            fontWeight={"Poppins_regular_large"}
            textAlign={"text_align_left"}
          />
        </div>
      );
    } else {
      return (
        <div style={{ flex: 1, alignItems: "left" }}>
          <div className="Kycdetails">
            <div className="KycLeft">
              <ul>
                <li>
                  <h6>Name :</h6>
                  <span>{contractData?.name || "N/A"}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      );
    }
  }

  const openModalFun = () => {
    if (modalIsOpen == false) {
      setModalIsOpen(true);
    } else {
      setModalIsOpen(false);
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  function renderRejectPayoutModal() {
    return (
      <Modal
        isOpen={rejectModalIsOpen}
        onRequestClose={closeRejectModal}
        style={CancelReminder}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            background: "#ffffff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 54,
          }}
        >
          <div onClick={closeRejectModal} className="close-btn-icon">
            <Icon iconName="CloseRoundButtonIcon" />
          </div>

          <CustomText
            p
            text={"Reject Payout"}
            textColor={"text_color_primary"}
            fontSize={"font_size_2xl"}
            className="typographyH7"
          />
        </div>
        <div className="create-assignment-container">
          <CustomText
            p
            fontSize={"font_size_medium"}
            textColor={"text_color_primary"}
            text={
              "Are you sure you want to reject this payout? This action cannot be undone."
            }
            noOfLine="2"
            className={"two-line-text"}
          />
        </div>
        <div className="create-assignment-container">
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              paddingTop: 20,
            }}
          >
            <div className="">
              <PrimaryCta
                invertSmall
                onClick={closeRejectModal}
                fontSize={"font_size_large"}
                text={"Cancel"}
              />
            </div>

            <div className=" m-l-32">
              <PrimaryCta
                fifth
                onClick={() => rejectPayout()}
                fontSize={"font_size_large"}
                text={"Reject Payout"}
                isLoading={rejectPayoutLoading}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  function renderAssignmentSignModal() {
    return (
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={CancelReminder}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            background: "#ffffff",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 54,
          }}
        >
          <div onClick={closeModal} className="close-btn-icon">
            <Icon iconName="CloseRoundButtonIcon" />
          </div>

          <CustomText
            p
            text={"Payout Completed"}
            textColor={"text_color_primary"}
            fontSize={"font_size_2xl"}
            className="typographyH7"
          />
        </div>
        <div className="create-assignment-container">
          <CustomText
            p
            fontSize={"font_size_medium"}
            textColor={"text_color_primary"}
            text={
              "Are you sure to mark this payout COMPLETED. This action can not be undo,"
            }
            noOfLine="2"
            className={"two-line-text"}
          />
        </div>
        <div className="create-assignment-container">
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              paddingTop: 20,
            }}
          >
            {/* <button
              style={{ color: "#090a14" }}
              className="confirm-btn-bid "
              onClick={closeModal}
            >
              Close
            </button> */}

            <div className="">
              <PrimaryCta
                invertSmall
                onClick={closeModal}
                fontSize={"font_size_large"}
                text={"Close"}
              />
            </div>
            <div className=" m-l-32">
              <PrimaryCta
                fifth
                onClick={() => payoutCompleteMarkAdmin()}
                fontSize={"font_size_large"}
                text={"Mark Completed"}
                isLoading={isLoading}
                //   disabled={!collectionId}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  return (
    <div className="dashboard-container">
      {/* <SideMenu /> */}
      <div className="" style={{ width: "100%" }}>
        {/* <Header /> */}
        <div className="m-t-20 m-b-20" style={{ width: "100%" }}>
          {isLoading ? (
            props.isEmbedded ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "16px 0",
                }}
              >
                <Loader />
              </div>
            ) : (
              <div className="loader-mid">
                <Loader />
              </div>
            )
          ) : (
            <>
              <div className="m-l-20 m-r-20 flex-jus-sp-al-center">
                <CustomText
                  h3
                  text={"Payout Details"}
                  textColor={"text_color_primary"}
                  fontSize={"font_size_xl"}
                  height={"line_height_24"}
                />
              </div>
              {/* ------------- KYC -----------------  */}
              {/* <div className="influencer-detail-category-modal-platform">
                  <div class="m-l-20">
                    <div className="m-b-12 ">
                      <div style={{ gap: 20 }} className="flex-row">
                        <CustomText
                          p
                          text={"KYC Details"}
                          fontSize={"font_size_large"}
                          textColor={"text_color_primary"}
                          fontWeight={"Poppins_regular_large"}
                          textAlign={"text_align_left"}
                        />
                      </div>

                      {influencerData ? (
                        renderkycOnConditions()
                      ) : (
                        <div className=" p-l-15 m-t-12">
                          <CustomText
                            p
                            text={"No KYC is verified."}
                            fontSize={"font_size_large"}
                            textColor={"text_color_primary"}
                            fontWeight={"Poppins_regular_large"}
                            textAlign={"text_align_left"}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div> */}

              <div
                style={{
                  display: "flex",
                  gap: 20,
                  marginLeft: 20,
                  marginRight: 20,
                }}
              >
                <div
                  className="influencer-detail-category-modal-platform"
                  style={{ flex: 1, padding: 0 }}
                >
                  <div
                    className="m-t-12 m-b-12"
                    style={{
                      backgroundColor: Theme.colors.BC_CARD,
                      borderRadius: 12,
                      boxShadow: "0 4px 12px rgba(9, 10, 20, 0.06)",
                      border: `1px solid ${Theme.colors.GREY_50}`,
                      padding: 16,
                      marginBottom:20,
                      flex: 1,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 12,
                        borderBottom: `1px solid ${Theme.colors.GREY_50}`,
                        paddingBottom: 12,
                      }}
                    >
                      <CustomText
                        p
                        text={"Payout Details"}
                        fontSize={"font_size_large"}
                        textColor={"text_color_primary"}
                        fontWeight={"Poppins_regular_large"}
                        textAlign={"text_align_left"}
                      />

                      {payoutListData?.status && (
                        <div style={getStatusChipStyle(payoutListData?.status)}>
                          {payoutListData?.status == "COMPLETED"
                            ? "Paid"
                            : payoutListData?.status}
                        </div>
                      )}
                    </div>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                        columnGap: 32,
                        rowGap: 8,
                        marginTop: 4,
                      }}
                    >
                      {renderSummaryItem(
                        "Status",
                        payoutListData?.status == "COMPLETED"
                          ? "Paid"
                          : payoutListData?.status,
                      )}
                      {renderSummaryItem("Campaign Name", contractData?.name)}
                      {renderSummaryItem(
                        "Campaign Type",
                        campaignData?.is_marketplace == 1
                          ? "Marketplace"
                          : campaignData?.is_marketplace == 0
                            ? "InHouse"
                            : "N/A",
                      )}
                      {renderSummaryItem(
                        "Initiated By",
                        payoutListData?.initiated_by,
                      )}
                      {renderSummaryItem(
                        "Contract Amount",
                        payoutListData?.order_amount != null
                          ? `₹ ${toFixedTwo(payoutListData?.contract_amount)}`
                          : null,
                      )}
                      {renderSummaryItem(
                        "Order Amount",
                        payoutListData?.order_amount != null
                          ? `₹ ${toFixedTwo(payoutListData?.order_amount)}`
                          : null,
                      )}
                      {renderSummaryItem(
                        "Tax",
                        payoutListData?.tax_amount != null
                          ? `₹ ${toFixedTwo(payoutListData?.tax_amount)}`
                          : null,
                      )}
                      {renderSummaryItem(
                        "Platform Fee",
                        payoutListData?.platform_charges != null
                          ? `₹ ${toFixedTwo(payoutListData?.platform_charges)}`
                          : null,
                      )}
                      {renderSummaryItem("Brand Name", props?.brand_name)}
                      {renderSummaryItem(
                        "Scheduled On",
                        payoutListData?.date_scheduled
                          ? Utils.formatDate(payoutListData?.date_scheduled)
                          : null,
                      )}
                      {renderSummaryItem(
                        "Initiated On",
                        payoutListData?.date_scheduled
                          ? Utils.formatDate(payoutListData?.initiated_at)
                          : null,
                      )}
                      {renderSummaryItem(
                        "Completed On",
                        payoutListData?.date_scheduled
                          ? Utils.formatDate(payoutListData?.date_completed)
                          : null,
                      )}
                    </div>

                    <div
                      style={{
                        marginTop: 16,
                        padding: "12px 0px",
                        borderRadius: 8,
                        backgroundColor: Theme.colors.BC_SEMI_LIGHT,
                        display: "flex",
                        borderTop: `1px solid ${Theme.colors.GREY_50}`,
                        gap: 12,
                        alignItems: "center",
                      }}
                    >
                      <CustomText
                        p
                        text={"Final Payout"}
                        fontSize={"font_size_small"}
                        textColor={"text_grey_400_color"}
                        fontWeight={"Poppins_regular_large"}
                        textAlign={"text_align_left"}
                      />
                      <CustomText
                        h3
                        text={
                          payoutListData?.payout_amount != null
                            ? `₹ ${toFixedTwo(payoutListData?.payout_amount)}`
                            : "N/A"
                        }
                        textColor={"text_color_primary"}
                        fontSize={"font_size_xl"}
                        height={"line_height_24"}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="influencer-detail-category-modal-platform"
                  style={{ flex: 1, padding: 0 }}
                >
                  <div
                    className="m-t-12 m-b-12"
                    style={{
                      backgroundColor: Theme.colors.BC_CARD,
                      borderRadius: 12,
                      boxShadow: "0 4px 12px rgba(9, 10, 20, 0.06)",
                      border: `1px solid ${Theme.colors.GREY_50}`,
                      flex: 1,
                      marginBottom:20,
                      padding: 16,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 12,
                        borderBottom: `1px solid ${Theme.colors.GREY_50}`,
                        paddingBottom: 14,
                      }}
                    >
                      <CustomText
                        p
                        text={"Influencer Details"}
                        fontSize={"font_size_large"}
                        textColor={"text_color_primary"}
                        fontWeight={"Poppins_regular_large"}
                        textAlign={"text_align_left"}
                      />
                    </div>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                        columnGap: 32,
                        rowGap: 8,
                        marginTop: 12,
                        marginBottom: 16,
                      }}
                    >
                      {renderSummaryItem(
                        "Name",
                        influencerData?.influencer_data?.name,
                      )}
                      {renderSummaryItem(
                        "Influencer Id",
                        influencerData?.influencer_data?.influencer_id,
                      )}
                    </div>

                    <CustomText
                      p
                      text={"Banking Info"}
                      fontSize={"font_size_large"}
                      textColor={"text_color_primary"}
                      fontWeight={"Poppins_regular_large"}
                      textAlign={"text_align_left"}
                    />

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                        columnGap: 32,
                        rowGap: 8,
                        marginTop: 12,
                      }}
                    >
                      {influencerData?.kyc_data?.find(
                        (k) => k?.kyc_type === "TAX_PROOF",
                      )?.kyc_value &&
                        renderSummaryItem(
                          "Tax Proof",
                          influencerData?.kyc_data?.find(
                            (k) => k?.kyc_type === "TAX_PROOF",
                          )?.kyc_value,
                        )}

                      {renderSummaryItem(
                        "Account Holder name",
                        influencerData?.bank_data?.account_holder_name,
                      )}
                      {renderSummaryItem(
                        "Account Number/UPI VPA",
                        influencerData?.bank_data?.account_number,
                      )}
                      {influencerData?.bank_data?.ifsc_code &&
                        renderSummaryItem(
                          "IFSC Code",
                          influencerData?.bank_data?.ifsc_code,
                        )}
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 10,
                  marginLeft: 20,
                  justifyContent: "end",
                  marginRight: 20,
                  marginBottom: 16,
                }}
              >
                <div
                  className=""
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    justifyContent: "right",
                  }}
                >
                  {payoutListData?.status == "PENDING" && (
                    <PrimaryCtaInvert
                      borderColor="var(--general-error)"
                      fontSize="font_size_small"
                      height="32px"
                      text="Reject Payout"
                      onClick={openRejectModal}
                      isLoading={false}
                    />
                  )}
                  
                  <div style={{ display: "flex", justifyContent: "left" }}>
                    <PrimaryCta
                      invertSmall
                      fontSize={"font_size_regular"}
                      text={"Contract Details"}
                      onClick={() => contactDetailPage(assignment_id)}
                    />
                  </div>
                  {payoutListData?.status == "PENDING" && (
                    <PrimaryCta
                      invertSmall
                      text={"Mark Completed"}
                      onClick={openModalFun}
                    />
                  )}
                  <PrimaryCta
                    fifth
                    fontSize={"font_size_regular"}
                    style={{
                      cursor:
                        isPayoutCompleted === "COMPLETED" ||
                        isPayoutCompleted === "PAYMENT_INITIATED"
                          ? "not-allowed"
                          : "pointer",
                    }}
                    text={
                      isPayoutCompleted == "COMPLETED"
                        ? "Transfer Completed"
                        : isPayoutCompleted == "PAYMENT_INITIATED"
                          ? "Payment Initiated"
                          : "Initiate Transfer"
                    }
                    disabled={
                      isPayoutCompleted == "COMPLETED" ||
                      isPayoutCompleted == "PAYMENT_INITIATED"
                    }
                    onClick={() => setOpenModal(true)}
                  />
                  
                </div>
              </div>

              {/* ---------- api call button ---------- */}

              {modalIsOpen && renderAssignmentSignModal()}
              {rejectModalIsOpen && renderRejectPayoutModal()}
              {/*  ----------- Confirmartion modal ---------- */}
              <ModalComponent
                isOpen={openModal}
                onRequestClose={() => setOpenModal(false)}
                customStyle={{
                  overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 999999,
                  },
                  content: {
                    top: "50%",
                    left: "50%",
                    right: "auto",
                    bottom: "auto",
                    // borderColor: "#f55879",
                    backgroundColor: "#F0F3F9",

                    marginRight: "-50%",
                    transform: "translate(-50%, -50%)",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
                  },
                }}
              >
                <div className="">
                  <CustomText
                    h5
                    text={"Are you sure For Initiate Transfer?"}
                    textColor={"text_grey_400_color"}
                    className="m-b-8 typographyBoldH5"
                  />
                </div>

                <div className="modal-btn-center">
                  <PrimaryCta
                    invertSmall
                    onClick={() => setOpenModal(false)}
                    fontSize={"font_size_large"}
                    text={"No"}
                  />

                  <PrimaryCta
                    third
                    fontSize={"font_size_regular"}
                    className="header-credit-right"
                    text={"Yes"}
                    isLoading={effectiveLoad}
                    onClick={() => handleInitateTransfer()}
                  />
                </div>
              </ModalComponent>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default PayoutDetailScreen;
const CancelReminder = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "var(--general-secondary-color)",
    textAlign: "center",
    zIndex: "5",
    height: "20%",
    display: "flex",
    flexDirection: "column",
    minHeight: "200px",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.95)",
    zIndex: 10,
  },
};
